<template>
  <!-- eslint-disable -->
  <div>
    <b-card no-body>
      <b-card-body>
        <b-row>
            <b-col sm="5" md="5" lg="2" xl="2" class="mb-md-0 mb-2">
                <b-form-group label="Tienda Origen" label-for="storeOrigin">
                <v-select
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="locals"
                    label="name"
                    v-model="storeOrigin"
                    :reduce="(locals) => locals.id"
                    input-id="storeOrigin"
                    @input="searchMov(storeOrigin)"
                />
                </b-form-group>
            </b-col>
            <b-col sm="5" md="5" lg="2" xl="2" class="mb-md-0 mb-2">
                <b-form-group label="Tienda Destino" label-for="storeDestination">
                <v-select
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="localsDestination"
                    label="name"
                    v-model="storeDestination"
                    :reduce="(localsDestination) => localsDestination.id"
                    input-id="storeDestination"
                />
                </b-form-group>
            </b-col>
            <b-col sm="5" md="5" lg="2" xl="2">
              <b-form-group label="Documento" label-for="document">
                <b-form-input
                  id="document"
                  placeholder="N° Documento"
                  v-model="document"
                  trim
                  @input="filter"
                />
              </b-form-group>
            </b-col>
            <b-col sm="5" md="5" lg="2" xl="2">
              <b-form-group label="Estado" label-for="state">
                <b-form-input
                  id="state"
                  placeholder="Estado"
                  v-model="state"
                  trim
                  @input="filter"
                />
              </b-form-group>
            </b-col>
            <b-col md="3" class="mt-2">
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="secondary"
                  class="mr-1"
                  @click.prevent="clean"
                >
                  <feather-icon icon="TrashIcon" class="mr-50" />
                  <span class="align-middle">Limpiar</span>
                </b-button>
            </b-col>
        </b-row>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
/* eslint-disable*/
import { BCard, BCardHeader, BCardBody, BRow, BCol, BButton,BFormGroup, BFormInput } from 'bootstrap-vue'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import StoresService from '@/services/StoresService'
export default {
  directives: {
    Ripple
  },
  data() {
    return {
      isAdd: false,
      isUpdate: false,
      codigo: '',
      arrayFilters: [],
      selectedLocal: null,
      locals: [],
      localsDestination: [],
      storeOrigin: null,
      storeDestination: null,
      document: '',
      state: '',
    }
  },
  components: {
    BButton,
    BFormInput,
    BFormGroup,
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    vSelect,
  },
  mounted() {
    this.getLocals()
  },
  methods: {
    async getLocals() {
      const url = `?limit=100&page=1&order=desc&sort=id&filter=${JSON.stringify(this.arrayFilters)}`;
      const resp = await StoresService.getStores(url,this.$store)
      if (resp) {
        this.locals = resp.data.rows
      }
    },
    filter() {
      this.arrayFilters = [];
      if (this.document !== '') {
        this.arrayFilters.push({
          keyContains: 'documentCode',
          key: 'contains',
          value: this.document
        })       
      }

      if(this.selectedLocal){
        this.selectedLocal.forEach((item) =>{
          this.arrayFilters.push({
            keyContains: 'establishments.id',
            key: 'equals',
            value: item.id
          });
        })
      }

      if (this.state !== '') {
        this.arrayFilters.push({
          keyContains: 'state',
          key: 'contains',
          value: this.state
        })       
      }

      this.$parent.$parent.arrayFilters = this.arrayFilters
      this.$parent.$parent.getData();
    },
    clean() {
      this.selectedLocal = null;
      this.arrayFilters = [];
      this.$parent.$parent.arrayFilters = this.arrayFilters
      this.$parent.$parent.getData();
    }
  }
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>